import Info from "../assets/images/info-icon.svg";

function CreditInfo({ }) {
    const creditInfoStyles = {
        position: 'relative',
        display: 'inline-block',
        cursor: 'pointer'
    };

    const iconStyles = {
        width: '20px',
        height: '20px',
        opacity: '0.7',
        transition: 'all 0.3s ease',
        filter: 'brightness(0) saturate(100%) invert(45%) sepia(8%) saturate(350%) hue-rotate(180deg)',
        marginLeft: '8px',
    };

    const tooltipStyles = {
        visibility: 'hidden',
        opacity: '0',
        position: 'absolute',
        top: '125%',
        left: '50%',
        marginLeft: '4px',
        transform: 'translateX(-50%)',
        backgroundColor: '#2c3e50',
        color: '#ffffff',
        padding: '12px 16px',
        borderRadius: '8px',
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: '1.4',
        whiteSpace: 'nowrap',
        zIndex: '9999',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
    };

    const tooltipArrowStyles = {
        content: '""',
        position: 'absolute',
        bottom: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        border: '6px solid transparent',
        borderBottomColor: '#2c3e50',
    };

    const containerHoverStyles = `
        .credit-info-container:hover .credit-tooltip {
            visibility: visible !important;
            opacity: 1 !important;
            transform: translateX(-50%) translateY(2px) !important;
        }
        .credit-info-container:hover .credit-icon {
            opacity: 1 !important;
            transform: scale(1.1) !important;
        }
    `;

    return (
        <>
            <style>{containerHoverStyles}</style>
            <div className="credit-info-container" style={creditInfoStyles}>
                <img 
                    src={Info} 
                    alt="Credit Information" 
                    className="credit-icon"
                    style={iconStyles}
                />
                <div className="credit-tooltip" style={tooltipStyles}>
                    <div style={tooltipArrowStyles}></div>
                    • Animation = free! 
                    <br />
                    • Video Session = 5 credits per 30 mins 
                    <br />
                    • Video + AI Audio Session = 10 credits per 30 mins
                </div>
            </div>
        </>
    );
}

export default CreditInfo
